/* eslint-disable */
<template>
  <div class="table-toolbar mb-3">
    <v-card class="mobile-height" elevation="0">
      <v-card-title class="main-toolbar">

          <!-- Bulb Grade Sync -->
          <div class="syncbuttonmenu"
            v-if="(
              activeViewInstructor === 'Interactions'
              || activeViewInstructor === 'Learner-Made-Bulb'
              || activeViewInstructor === 'Peer-Review'
            )
            && (
              queryParamsInstructors.section_id == LTIdata.section_id
              || queryParamsInstructors.lms_class
            )
            && this.isGradingEnabled
            && lmsType !== 'Google'"
          >
              <v-btn name="sync"
                class="branded-background text-white"
                @click="syncLti({
                  resourceLinkId: activeResourceLinkId,
                  consumerKey: activeConsumerKey
                })"
                :disabled="!checkForSyncData"
              >
                <div class="row-center">
                  <v-icon  class="text-white" >autorenew</v-icon>
                  <span class="text-white" style="padding-left: 8px;">Sync Grades</span>
                  <img  :src="lmsImg" class="lms-img" style="margin-left: 8px;">
                </div>
              </v-btn>
              <v-menu offset-y nudge-left="196" attach="syncbuttonmenu" style="width:36px !important; margin-left:-7px;" :disabled="!checkForSyncData">
                <div :class="checkForSyncData ? 'add-more-options' : 'add-more-options-disabled'" slot="activator">
                  <v-icon  class="branded-text" :disabled="!checkForSyncData">keyboard_arrow_down</v-icon>
                </div>
                <div class="add-more-sync">
                  <v-btn text flat class="branded-text" @click="handleDialogOpen({
                    type: 'ltiSync',
                    data: {
                      contentId: queryParamsInstructors.bulb_id,
                      renderPath: 'play2,broadcast2,studentmade2,legacy-log',
                      image: lmsImg,
                      consumer_key_resource_link_id: LTIdata.resource_link_id,
                      syncStatusTitle: gradebookBreadcrumbs[0].text || 'Bulb'
                    }
                  })">Check Sync Status</v-btn>
                </div>
              </v-menu>
          </div>

          <div class="select-actions" v-if="selectedData.length > 0">
              <!--<v-icon class="branded-text">check_box</v-icon>-->
              <span style="margin-left: 5px; width:100px;">{{selectedData.length}} selected</span>
              <v-btn v-if="activeViewInstructor === 'Learners' && !queryParamsInstructors.lms_class" class="branded-text" text flat @click="handleDialogOpen({type:'remove', data:{}})">Remove From Class</v-btn>
              <v-btn  v-if="activeViewInstructor === 'Learners' && !queryParamsInstructors.lms_class" class="branded-text" text flat @click="handleDialogOpen({type:'moveMenu', data:{}})" >Move To Other Class</v-btn>
              <Tooltip v-if="activeViewInstructor === 'Learners' && queryParamsInstructors.lms_class && !LTIlaunch" top>
                <v-btn  class="branded-text" text flat >Remove From Class</v-btn>
                <template v-slot:text>
                  Learners must be managed from LTI
                </template>
              </Tooltip>
              <Tooltip  v-if="activeViewInstructor === 'Learners' && queryParamsInstructors.lms_class && !LTIlaunch" top>
                <v-btn  v-if="activeViewInstructor === 'Learners' && queryParamsInstructors.lms_class" class="branded-text" text flat  >Move To Other Class</v-btn>
                <template v-slot:text>
                  Learners must be managed from LTI
                </template>
              </Tooltip>
              <v-btn
                @click="instructorData.migrated ? null : handleDialogOpen({type:'confirm', data:{type:'reset'}})"
                v-if="activeViewInstructor === 'Interactions'"
                :disabled="!!instructorData.migrated"
                class="branded-text"
                text
                flat
              >
                Reset Bulb Attempt
              </v-btn>
              <v-btn
                @click="instructorData.migrated ? null : setDashModal({ type: 'confirmResetPlaylistAttempt', playlist: playlistSelected })"
                v-if="activeViewInstructor === 'Gradebook'"
                :disabled="!!instructorData.migrated"
                class="branded-text"
                text
                flat
              >
                  Reset Playlist Attempts
              </v-btn>
              <div class="playlistsyncbuttonmenu"
                v-if="isGradingEnabled && playlistSelected">
                <v-btn
                  name="sync-playlist"
                  class="branded-background text-white"
                  @click="syncLti({
                    contentId: selectedPlaylist,
                    sectionId,
                    renderPath: 'playlist',
                  })"
                  :disabled="!checkForSyncData">
                  <div class="row-center">
                    <v-icon  class="text-white">autorenew</v-icon>
                    <span class="text-white pl-2">Sync Grades</span>
                    <img :src="lmsImg" class="lms-img ml-2">
                  </div>
                </v-btn>
                <v-menu offset-y nudge-left="196" attach="syncbuttonmenu" style="width:36px !important; margin-left:-12px;" :disabled="!checkForSyncData">
                  <div :class="checkForSyncData ? 'add-more-options' : 'add-more-options-disabled'" slot="activator">
                    <v-icon  class="branded-text" :disabled="!checkForSyncData">keyboard_arrow_down</v-icon>
                  </div>
                  <div class="add-more-sync">
                    <v-btn
                      text
                      flat
                      class="branded-text"
                      @click="handleDialogOpen({
                        type:'ltiSync',
                        data:{
                          contentId: selectedPlaylist,
                          renderPath: 'playlist',
                          image: lmsImg,
                          syncStatusTitle: _.get(_.find(sectionPlaylists, { id: selectedPlaylist }), 'name', 'Playlist')
                        }
                      })
                    ">Check Playlist Sync Status</v-btn>
                  </div>
                </v-menu>
              </div>
              <span v-if="activeViewInstructor === 'Learners' && LTIlaunch">Learners must be managed from LTI</span>
              <v-btn
                v-if="activeViewInstructor === 'Learner-Made-Bulb'"
                class="branded-text"
                text
                flat
                @click="handleDialogOpen({type:'confirm', data:{type:'lmbreset'}})">
                Reset Learner Made Bulb
              </v-btn>
              <v-btn
                v-if="activeViewInstructor === 'My-Bulbs' || activeViewInstructor === 'Bulbs'"
                class="branded-text"
                text
                flat
                @click="slideOut({ toggle: true, view: 'batchSettings', location: 'My-Bulbs', bulbs: selectedData });"
                :disabled="selectedData.length > 20">
                Batch Settings
              </v-btn>
              <v-btn
                v-if="activeViewInstructor === 'My-Bulbs' || activeViewInstructor === 'Bulbs'"
                class="branded-text"
                text
                flat
                @click="manageCoOwners"
                :disabled="selectedData.length > 20">
                Manage Permissions
              </v-btn>
              <v-btn
                @click="handleDialogOpen({type:'confirm', data:{type:'reset'}})"
                v-if="activeViewInstructor === 'Peer-Review'"
                flat
                :disabled="instructorAjaxing"
                name="resetLearnerAttempt"
                class="branded-text"
              >
                Reset attempt{{selectedData.length === 1 ? '' : 's'}}
              </v-btn>
              <v-btn
                v-if="activeViewInstructor === 'My-Bulbs'"
                color="error"
                text
                flat
                @click="handleDialogOpen({
                  type: 'remove' ,
                  data: selectedData.map((bulb) => bulb.id)
                })"
              >
                Delete
              </v-btn>
              <v-btn
                v-if="activeViewInstructor === 'Folder' || activeViewInstructor === 'Folders'"
                class="branded-text"
                text
                flat
                @click="manageCoOwnersForFolders"
                :disabled="selectedData.length > 20">
                Manage Bulb Permissions
              </v-btn>
              <v-btn
                v-if="activeViewInstructor === 'Folder' || activeViewInstructor === 'Folders'"
                class="branded-text"
                text
                flat
                @click="foldersBatchSettings"
                :disabled="selectedData.length > 20">
                Batch Settings
              </v-btn>
          </div>

          <!--action buttons-->
          <template v-if="selectedData.length === 0" >
            <v-btn v-if="Object.keys(premadeFilters).length > 0" text class="branded-background text-white" @click="clearAllFilters">Clear Filters</v-btn>


            <div
              class="padding-right"
              v-if="selectedData.length === 0 && Object.keys(premadeFilters).length === 0 && (activeViewInstructor ==='Classes')"
              id="add-new-class">
              <v-btn
                @click="instructorData.migrated ? null : handleDialogOpen({type: 'addMenu', data: {}})"
                :disabled="!!instructorData.migrated"
                text
                name="add"
                class="branded-background text-white"
              >
                Add New Class
              </v-btn>
              <v-menu
                v-if="activeViewInstructor === 'Classes' && !instructorData.migrated"
                offset-y
                nudge-left="140"
                attach="#add-new-class"
                style="width:36px !important; margin-left:-7px;"
              >
                <div class="add-more-options" slot="activator">
                  <v-icon  class="branded-text">keyboard_arrow_down</v-icon>
                </div>
                <div>
                  <v-list>
                    <v-list-tile
                      class="branded-text"
                      avatar
                      @click="handleGoogleClassPicker">
                      <v-list-tile-avatar
                        size=32
                        tile>
                        <img src="https://bunny.playposit.com/images/add_to_googleclassroom.png" alt="Google Classroom Logo">
                      </v-list-tile-avatar>
                      <v-list-tile-title>Import from Google Classroom</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
              </v-menu>
            </div>

            <div class="padding-right"
              v-if="activeViewInstructor === 'Folders'">
              <v-btn
                @click="instructorData.migrated ? null : handleDialogOpen({type: 'addFolder', data: {}})"
                :disabled="!!instructorData.migrated"
                text
                name="addFolder"
                class="branded-background text-white"
              >
                Add Folder
              </v-btn>
            </div>

            <div class="padding-right"
              v-if="activeViewInstructor === 'Folder'">
              <v-btn
                @click="instructorData.migrated ? null : handleDialogOpen({type: 'addFolder', data: {}})"
                :disabled="!!instructorData.migrated"
                text
                name="addFolder"
                class="branded-background text-white"
              >
                Add Subfolder
              </v-btn>
            </div>


            <div id="add-new-bulb" class="padding-right add-more-menu-container"
              v-if="selectedData.length === 0 && Object.keys(premadeFilters).length === 0 && (activeViewInstructor ==='My-Bulbs') && !passbackLinking" >
                <v-btn
                  @click="instructorData.migrated ? null : addBulb()"
                  :disabled="!!instructorData.migrated"
                  text
                  name="add"
                  slot="activator"
                  class="branded-background text-white"
                >
                  Add New Bulb
                </v-btn>
                <v-menu
                  v-if="activeViewInstructor === 'My-Bulbs' && instructorType != 'free' && !instructorData.migrated"
                  offset-y
                  nudge-left="127"
                  attach="#add-new-bulb"
                  style="width:36px !important; margin-left:-12px;"
                >
                  <div class="add-more-options" slot="activator">
                    <v-icon class="branded-text">keyboard_arrow_down</v-icon>
                  </div>
                  <div class="add-more-menu">
                    <v-list>
                      <v-list-tile class="branded-text" @click="handleDialogOpen({type:'lmb', data:{}})">
                        <v-list-tile-title>Add Learner Made Bulb</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-if="_.get(school, 'config.permissions', []).includes('hasPeerReview')" class="branded-text" @click="handleDialogOpen({type:'lmb', data:{peer_review: true}})">
                        <v-list-tile-title>Add Peer Review Assignment</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </div>
                </v-menu>
            </div>
            <div id="add-learners" class="add-more-menu-container" v-if="selectedData.length === 0 && activeViewInstructor ==='Learners' && queryParamsInstructors.section_id != '' && (!queryParamsInstructors.lms_class || ['SchoologyFree', 'Google', 'Clever'].includes(selectedClass.lmsType)) && !LTIlaunch && [1, 2].includes(this.selectedClass.containerRole)" >
                <v-btn
                  @click="instructorData.migrated ? null : uploadLearners()"
                  :disabled="!!instructorData.migrated"
                  text
                  name="add"
                  class="branded-background text-white"
                >
                  Add Learners
                </v-btn>
            </div>
            <div
              id="directClassLink"
              class="add-more-menu-container"
              v-if="
              selectedData.length === 0
              && hasJoinURLAccess
              && activeViewInstructor === 'Learners'
              && queryParamsInstructors.section_id != ''
              && (
                !queryParamsInstructors.lms_class
                || ['SchoologyFree', 'Google', 'Clever'].includes(selectedClass.lmsType)
              )
              && !LTIlaunch
              && [1, 2].includes(this.selectedClass.containerRole)">
                <v-btn
                  text
                  @click="handleDirectURLClicked"
                  outline
                  class="branded-text">
                  Join URL
                </v-btn>
            </div>
            <div class="padding-right"
              v-if="selectedData.length === 0 && queryParamsInstructors.lms_class && !['SchoologyFree', 'Google', 'Clever'].includes(selectedClass.lmsType) && activeViewInstructor ==='Learners' && queryParamsInstructors.section_id != '' && !LTIlaunch">
                <Tooltip top>
                  <v-btn  text class="branded-background text-white">
                    Add Learners
                  </v-btn>
                  <template v-slot:text>
                    Learners must be added from LTI
                  </template>
                </Tooltip>
            </div>

            <div class="padding-right"
              v-if="activeViewInstructor ==='Learners' && queryParamsInstructors.section_id != '' && (_.get(school, 'config.permissions', []).includes('manageGroups') || _.get(school, 'config.permissions', []).includes('hasPeerReview')) && [1, 2].includes(this.selectedClass.containerRole)">
                <v-btn text name="manageGroups" outline @click="slideOut({ toggle: true, view: 'groups', sectionId: queryParamsInstructors.section_id })" class="branded-text">
                  Groups
                </v-btn>
            </div>


            <div class="padding-right"
              v-if="false">
                <v-btn  text class="branded-background text-white" @click="handleDialogOpen({type:'addVideo', data:{}})">
                  Upload Video
                </v-btn>
            </div>

            <div
              xs2
              v-if="selectedData.length === 0 && activeViewInstructor ==='Gradebook' && hasPlaylistAccess"
              class="playlistSelect mr-2"
            >
              <v-select
                v-model="selectedPlaylist"
                :items="sectionPlaylists"
                item-text="name"
                item-value="id"
                @change="loadPlaylistGradebook()"
                hide-details
                class="selectClassTruncate"
                >
              </v-select>
            </div>
            <div class="padding-right"
              v-if="selectedData.length > 0 && activeViewInstructor === 'Gradebook'">
              <v-btn  text class="branded-background text-white">Reset Attempts</v-btn>
            </div>
            <v-flex
              xs4 align-self-center
              v-if="selectedData.length === 0
                && activeViewInstructor === 'Gradebook'
                && selectedPlaylist !== 'All Bulbs'
                && isGoogleSection
                && selectedPlaylistCourseWorkId
                && gradebook.data
                && isSchoolUser
                && [1, 2].includes(selectedClass.containerRole)
              ">
              <div>
                <v-btn name="sync"
                  class="branded-background text-white"
                  @click="syncGoogleGrades()"
                  :loading="instructorAjaxing"
                >
                  <v-icon  class="text-white" >autorenew</v-icon>
                  <span class="text-white" style="padding-left: 8px;">Sync Grades</span>
                  <v-list-tile-avatar
                    class="d-inline-flex"
                    size=32
                    tile>
                    <img src="https://bunny.playposit.com/images/add_to_googleclassroom.png" alt="Google Classroom Logo">
                  </v-list-tile-avatar>
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs4 align-self-center v-if="
              selectedPlaylist !== 'All Bulbs'
              && (queryParamsInstructors.section_id == LTIdata.section_id || queryParamsInstructors.lms_class)
              && activeViewInstructor === 'Gradebook'
              && lmsType !== 'Google'
            "
            >
            <div class="playlistsyncbuttonmenu"
              v-if="isGradingEnabled && playlistSelected">
                <v-btn
                  name="sync-playlist"
                  class="branded-background text-white"
                  @click="syncLti({
                    contentId: selectedPlaylist,
                    sectionId,
                    renderPath: 'playlist',
                  })"
                  :disabled="!checkForSyncData"
                >
                  <div class="row-center">
                    <v-icon  class="text-white">autorenew</v-icon>
                    <span class="text-white pl-2">Sync Grades</span>
                    <img :src="lmsImg" class="lms-img ml-2">
                  </div>
                </v-btn>
                <v-menu offset-y nudge-left="196" attach="syncbuttonmenu" style="width:36px !important; margin-left:-12px;" :disabled="!checkForSyncData">
                  <div :class="checkForSyncData ? 'add-more-options' : 'add-more-options-disabled'" slot="activator">
                    <v-icon  class="branded-text" :disabled="!checkForSyncData">keyboard_arrow_down</v-icon>
                  </div>
                  <div class="add-more-sync">
                    <v-btn text flat class="branded-text" @click="handleDialogOpen({
                        type:'ltiSync',
                        data:{
                          contentId: selectedPlaylist,
                          renderPath: 'playlist',
                          image: lmsImg,
                          syncStatusTitle: _.get(_.find(sectionPlaylists, { id: selectedPlaylist }), 'name', 'Playlist')
                        }
                      })
                    ">Check Playlist Sync Status</v-btn>
                  </div>
                </v-menu>
              </div>
            </v-flex>
            <!--Collaborate-->
            <div class="padding-right"
              v-if="activeViewInstructor === 'Bulbs'
                && !queryParamsInstructors.lms_class && _.get(this.school, 'id')
                && this.selectedClass.containerRole < 4
                && isSchoolUser
                && !isGoogleSection"
            >
              <v-btn
                @click="instructorData.migrated ? null : handleDialogOpen({type: 'coursePermission', data: selectedClass})"
                :disabled="!!instructorData.migrated"
                text
                name="collaborate"
                class="branded-background text-white"
              >
                Collaborate
              </v-btn>
            </div>
            <!--Playlist Select-->
            <div class="padding-right"
              v-if="activeViewInstructor === 'Bulbs' && !queryParamsInstructors.lms_class && [1, 2, 3].includes(this.selectedClass.containerRole) && sectionHasPlaylist">
              <v-menu>
                <template
                  v-slot:activator="{ on }">
                  <v-btn v-on="on" text  name="managePlaylist" outline class="branded-text">Manage Playlist</v-btn>
                </template>
                  <v-list>
                    <v-subheader>Select playlist:</v-subheader>
                    <v-list-tile
                      v-for="(playlist, index) in sectionPlaylists"
                      :key="index"
                      @click="managePlaylist({playlistId: playlist.id, sectionId: queryParamsInstructors.section_id})">
                      <v-list-tile-title>{{ playlist.name }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
              </v-menu>
            </div>
            <!-- Google Grade Sync -->
            <div
              v-if="selectedData.length === 0
              && activeViewInstructor === 'Interactions'
              && isGoogleSection
              && courseWorkId
              && interactions.data
              && isSchoolUser
              && [1, 2].includes(selectedClass.containerRole)">
              <v-btn name="sync"
                class="branded-background text-white pr-1"
                @click="syncGoogleGrades()"
                :loading="instructorAjaxing"
              >
                <v-icon  class="text-white" >autorenew</v-icon>
                <span class="text-white" style="padding-left: 8px;">Sync Grades</span>
                <v-list-tile-avatar
                  class="d-inline-flex"
                  size=32
                  tile>
                  <img src="https://bunny.playposit.com/images/add_to_googleclassroom.png" alt="Google Classroom Logo">
                </v-list-tile-avatar>
              </v-btn>
            </div>

            <!-- Button to show bulb analytics -->
            <div id="bulbAnalytics" class="padding-right"
            v-if="activeViewInstructor === 'Interactions'  && queryParamsInstructors.lmb_bulb === ''">
              <v-btn text flat name="showBulbAnalytics" :disabled="instructorAjaxing || !dynamicDataLoaded" class="branded-text" @click="handleDialogOpen({type:'bulbAnalytics', data:{type: 'Bulb Analytics', icon: 'assessment', bulb_id: queryParamsInstructors.bulb_id, section_id: queryParamsInstructors.section_id}})" tabindex="0">
                Bulb Analytics
              </v-btn>
            </div>

            <div id="filteredBy" class="padding-right" v-if="(activeViewInstructor === 'Interactions' || activeViewInstructor === 'Gradebook') && filtersInteraction.isFiltered">
              <span
                v-if="filtersInteraction.isFiltered"
                style="margin-left: 5px; width:80px; min-width: 80px;"
              >
                Filtered by:
              </span>
              <v-chip
                v-if="filtersInteraction.selectedStatus !== 'All'"
                light
                color="white"
              >
                <label>Status</label>
                <v-chip
                  close
                  outline
                  small
                  color="grey"
                  @input="closeInteractionFilterTag('selectedStatus')"
                >
                  {{filtersInteraction.selectedStatus}}
                </v-chip>
              </v-chip>
              <v-chip
                v-if="filtersInteraction.showPointsBadges"
                light
                color="white"
              >
                <label>Show point values</label>
                <v-chip
                  close
                  outline
                  small
                  color="grey"
                  @input="closeInteractionFilterTag('showPointsBadges')"
                >
                  {{filtersInteraction.showPointsBadges}}
                </v-chip>
              </v-chip>
            </div>

            <div
              v-if="(
                isProquest
                && [
                  'Student-Interaction',
                  'Single-Interaction',
                ].includes(activeViewInstructor)
              )"
              id="proquest-back-button-wrapper"
              class="padding-right"
            >
            <v-btn
              @click="returnToProquestMonitorPage"
              class="proquest-back-button"
              outline
            >
              <v-icon left>chevron_left</v-icon>
              Back
            </v-btn>
          </div>

            <div
              class="grade padding-right"
              v-if="showGradeAnswers"
            >
              <v-btn flat :disabled ="instructorAjaxing" name="grade" v-if="!editGrades" @click="toggleEditGrades" class="branded-text branded-border">
                Enter Grade Mode
              </v-btn>
              <v-btn  :disabled ="instructorAjaxing" name="grade"  v-if="editGrades" @click="toggleEditGrades(false)" class="branded-background text-white">
                Save Grades
              </v-btn>
            </div>

            <div v-if="activeViewInstructor === 'Learners' && selectedData.length === 0 && !queryParamsInstructors.lms_class && Object.keys(premadeFilters).length === 0 && [1, 2].includes(this.selectedClass.containerRole)">
              <span style="padding-right: 36px;"><span class="bold">Class Code:</span> {{instructorData.id}}-{{queryParamsInstructors.section_id}}</span>
            </div>

            <div
              v-if="activeViewInstructor ==='Playlists'"
              id="add-new-playlist"
              class="padding-right add-more-menu-container"
            >
              <v-btn
                @click="instructorData.migrated ? null : handleCreatePlaylist()"
                :disabled="!!instructorData.migrated"
                text
                class="branded-background text-white"
                aria-label="Add New Playlist"
              >
                Add New Playlist
              </v-btn>
            </div>
          </template>
          <v-spacer></v-spacer>

          <!--data manipulation buttons-->
          <div class="data-manipulation" v-if="selectedData.length === 0 ">
            <div v-if="activeViewInstructor === 'Classes'" class="archived-classes">
              <v-switch v-model="classes.archived" color="grey" label="Show Archived Classes" height="30"></v-switch>
            </div>

            <div  v-if="activeViewInstructor === 'My-Bulbs' && stateDataLoaded" style="width: 120px; ">
              <v-menu
                v-model="popoverToggles.filterMenu"
                :close-on-content-click="false"
                :nudge-width="400"
                :disabled="this.instructorAjaxing || selectedData.length > 0"
                attach
                :nudge-left="filterMenuNudgeLeft"
                z-index="11"
              >
                <v-btn name="filter" flat slot="activator" class="branded-text" :disabled="this.instructorAjaxing || selectedData.length > 0">
                  <v-icon style="padding-right:5px;">filter_list</v-icon>
                  Filter
                </v-btn>
                <Popover
                  id="dash-popovers"
                  v-if="popoverToggles.filterMenu">
                </Popover>
              </v-menu>
            </div>
            <div v-if="activeViewInstructor === 'Gradebook' && queryParamsInstructors.lmb_bulb === '' && stateDataLoaded && playlistSelected" style="width: 120px">
              <v-menu
                v-model="popoverToggles.filterMenuPlaylist"
                :close-on-content-click="false"
                :nudge-width="400"
                :disabled="this.instructorAjaxing || selectedData.length > 0"
                attach
                nudge-left="530"
                z-index="11"
              >
                <v-btn
                  name="filter"
                  flat
                  slot="activator"
                  class="branded-text"
                  :disabled="this.instructorAjaxing || selectedData.length > 0"
                >
                  <v-icon style="padding-right:5px;">filter_list</v-icon>
                  Filter
                </v-btn>
                <Popover v-if="popoverToggles.filterMenuPlaylist"></Popover>
              </v-menu>
            </div>
            <div v-if="activeViewInstructor === 'Interactions' && queryParamsInstructors.lmb_bulb === '' && stateDataLoaded" style="width: 120px; ">
              <v-menu
                v-model="popoverToggles.filterMenuInteraction"
                :close-on-content-click="false"
                :nudge-width="400"
                :disabled="this.instructorAjaxing || selectedData.length > 0"
                attach
                nudge-left="530"
                z-index="11"
              >
                <v-btn name="filter"  flat slot="activator" class="branded-text" :disabled="this.instructorAjaxing || selectedData.length > 0">
                  <v-icon style="padding-right:5px;">filter_list</v-icon>
                  Filter
                </v-btn>
                <Popover
                  id="dash-popovers"
                  v-if="popoverToggles.filterMenuInteraction">
                </Popover>
              </v-menu>
            </div>

            <div  v-if="activeViewInstructor === 'My-Community' || activeViewInstructor === 'Premade-Bulbs' || activeViewInstructor === 'Premade-Bulbs-Legacy' || activeViewInstructor === 'My-Community-Legacy'" style="width: 120px; ">
              <v-menu
                v-model="popoverToggles.filterMenu"
                :close-on-content-click="false"
                :nudge-width="400"
                :disabled="this.instructorAjaxing || selectedData.length > 0"
                attach
                nudge-left="530"
                z-index="11"
              >
                <v-btn name="filter"  flat slot="activator" class="branded-text">
                  <v-icon>search</v-icon>
                  Search
                </v-btn>
                <Popover
                  id="dash-popovers"
                  v-if="popoverToggles.filterMenu"
                  type="filters">
                </Popover>
              </v-menu>
            </div>

            <div
              v-if="activeViewInstructor === 'Playlists'
                && stateDataLoaded"
              style="width: 120px;"
            >
              <v-menu
                v-model="popoverToggles.filterMenu"
                :close-on-content-click="false"
                :nudge-width="400"
                :disabled="this.instructorAjaxing || selectedData.length > 0"
                attach
                :nudge-left="filterMenuNudgeLeft"
                z-index="11"
              >
                <v-btn
                  name="filter"
                  flat
                  slot="activator"
                  class="branded-text"
                  :disabled="this.instructorAjaxing || selectedData.length > 0"
                >
                  <v-icon style="padding-right:5px;">filter_list</v-icon>
                  Filter
                </v-btn>
                <Popover
                  id="dash-popovers"
                  v-if="popoverToggles.filterMenu">
                </Popover>
              </v-menu>
            </div>

            <v-btn
              v-if="activeViewInstructor === 'Gradebook'"
              flat
              class="mr-3 branded-text"
              @click="updateShowPointsMode(!showPointsMode)"
            >
              {{scoreFormat}}
            </v-btn>

            <div class="search" @submit.prevent="search"
            v-if="(
            activeViewInstructor != 'My-Community' &&
            activeViewInstructor != 'Premade-Bulbs' &&
            activeViewInstructor != 'Premade-Bulbs-Legacy' &&
            activeViewInstructor != 'My-Community-Legacy'
            )">
              <v-form class="search-form tabable">
                <v-text-field
                v-model="queryParamsInstructors.search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
                @click:append="search"
                @click:clear="clearSearch"
                clearable
                :disabled="this.instructorAjaxing || selectedData.length > 0"
                ></v-text-field>
              </v-form>
            </div>

            <div class="center-btn">
              <v-btn
                id="instructorTableDataRefreshButton"
                :disabled ="(
                  this.instructorAjaxing
                  || selectedData.length > 0
                )"
                name="refresh"
                icon
                @click="refresh"
                class="tabable refresh"
                tabindex=0
                aria-label="Refresh table"
              >
                <Tooltip top>
                  <v-icon >refresh</v-icon>
                  <template v-slot:text>
                    Refresh Data
                  </template>
                </Tooltip>
              </v-btn>
            </div>
            <!-- START data export -->
            <v-btn name="export" flat icon class="branded-text" @click="handleDialogOpen({ type:'export', data: { analytics: false, bulb_name: '', bulb_id: '', playlist_id: selectedPlaylist } })"  :disabled="this.instructorAjaxing || selectedData.length > 0" v-if="
            activeViewInstructor != 'Premade-Bulbs'
            && activeViewInstructor != 'Premade-Bulbs-Legacy'
            && activeViewInstructor != 'My-Videos'
            && activeViewInstructor != 'Classes'
            && activeViewInstructor != 'My-Community'
            && activeViewInstructor != 'My-Community-Legacy'
            && activeViewInstructor != 'Learner-Made-Bulb-Monitor'
            && activeViewInstructor != 'Folders'
            && activeViewInstructor != 'Folder'
            && activeViewInstructor != 'Subfolder'
            && activeViewInstructor != 'Playlists'
            && !passbackLinking
            "
              aria-label="Export Data">
              <Tooltip top>
                <v-icon>cloud_download</v-icon>
                <template v-slot:text>
                  Data Export
                </template>
              </Tooltip>

            </v-btn>
            <!-- END data-export-->

          </div>
        </v-card-title>
         <div class="filters"
         v-if="(
         activeViewInstructor === 'Premade-Bulbs' ||
         activeViewInstructor === 'Premade-Bulbs-Legacy' ||
         activeViewInstructor === 'My-Bulbs' ||
         activeViewInstructor === 'Playlists' ||
         activeViewInstructor === 'My-Community' ||
         activeViewInstructor === 'My-Community-Legacy'
         ) &&  Object.keys(premadeFilters).length > 0">
            <span style="margin-left: 5px; width:80px; min-width: 80px;">Filtered by:</span>
            <div class="filters-overflow">
              <v-chip color="white" v-for="(value, key) in premadeFilters" :key="key" class="chip-container">
                <span :style="tagTextStyle(key)">{{key.replace('-', ' ')}}:</span>
                <v-chip v-for="(item, index) in premadeFilters[key]" :style="tagStyle(key)" :key="item" close @input="clearFilter([key, item])">
                  <span :style="tagTextStyle(key)">{{item}}</span>
                </v-chip>
              </v-chip>
            </div>
        </div>
      </v-card>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import router from '../../router';
import Color from 'color';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Popover from '../Popover';

export default {
  name: 'instructor-table-toolbar',
  components: {
    Popover
  },
  data() {
    return {
      activeConsumerKey: null,
      activeResourceLinkId: null,
      coOwnerMenu: false,
      lmsImg: 'https://cdn.playposit.com/image-uploads/image-22-05-2019-15-35-00--lms_default.png',
      ownsAllBulbs: true,
      selectedPlaylist: "All Bulbs",
      filterMenuNudgeLeft: 530,
      windowInnerWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapState('instructors', [
      'courseWorkId',
      'enableGrading',
      'sectionHasPlaylist',
      'sectionPlaylists',
      'showPointsMode',
    ]),
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'dialogShow',
      'instructorData',
      'popoverToggles',
      'nodeApiPrefix',
      'lmb',
      'LMSdata',
      'breadcrumbs',
      'designerApiPrefix',
      'LTIlaunch',
      'LTIdata',
      'instructorType',
      'stateDataLoaded',
      'school',
      'passbackLinking',
      'peerReviewSchool',
      'legacy',
      'slideOutLarge',
    ]),
    ...mapGetters('instructors', [
    'activeViewInstructor',
    'instructorAjaxing',
    'editGrades',
    'queryParamsInstructors',
    'selectedData',
    'dynamicDataLoaded',
    'bulbs',
    'gradebook',
    'bulbattempts',
    'interactions',
    'studentbulbattempts',
    'singleinteraction',
    'studentinteraction',
    'gradebookBreadcrumbs',
    'filterSearch',
    'tags',
    'classes',
    'lmb',
    'peerreview',
    'filtersInteraction',
  ]),
  isProquest() {
    return (
      this.queryParamsInstructors?.isProquest
      || this.queryParamsAdmin?.isProquest
    );
  },
  hasPlaylistAccess() {
    return (_.get(this.school, 'config.permissions', []).includes('hasPlaylistAccess') || this.sectionHasPlaylist);
  },
  hasJoinURLAccess() {
    return _.get(this, 'school.permissionKeys', []).includes('hasJoinURLAccess');
  },
  isGoogleSection() {
    return _.get(this.selectedClass, 'lmsType', '') === 'Google';
  },
  isSchoolUser() {
    // If there is a school.id show bulkSelect/CoOwners column
    if (_.get(this, 'school.id')) return true;
    // If school.id is null - hide bulkSelect/CoOwners column
    return false;
  },
  lmsType() {
    return _.get(this.selectedClass, 'lmsType', null);
  },
  selectedPlaylistCourseWorkId() {
    return this.playlistSelected?.courseWorkId;
  },
  playlistSelected() {
    return _.find(this.sectionPlaylists, { 'id': this.selectedPlaylist });
  },
  scoreFormat() {
    return this.showPointsMode ? 'Show Percent' : 'Show Points';
  },
  selectedClass() {
    if (this.queryParamsInstructors.section_id) {
      return _.find(this.classes.data, c => {
        return c.id === parseInt(this.queryParamsInstructors.section_id, 10);
      }) || {};
    }
    return {};
  },
  showGradeAnswers() {
    // make sure at least one row contains data required for grade saving
    if (this.selectedData.length === 0 && Object.keys(this.premadeFilters).length === 0) {
      if (this.activeViewInstructor === 'Learner-Made-Bulb') {
        return _.findIndex(this.lmb.data, b => b.status !== 'Not Started') >= 0;
      }
      else if (this.activeViewInstructor === 'Single-Interaction') {
        return _.findIndex(this.singleinteraction.data, i => _.has(i, 'completed')) >= 0;
      }
      else if (this.activeViewInstructor === 'Student-Interaction') {
        return _.findIndex(this.studentinteraction.data, i => _.has(i, 'interaction_attempt_id')) >= 0;
      } else if (this.activeViewInstructor === 'Peer-Review') {
        return _.findIndex(this.peerreview.data, p => _.get(p, 'bulb_attempt_id', -1)) > -1;
      }
      return false;
    }
  },
    searchWatch: function() {
      //returns search query param
      return this.queryParamsInstructors.search;
    },
    classesLoaded: function(){
      return this.classes.data;
    },
    sectionId: function(){
      return this.queryParamsInstructors.section_id;
    },
    isGradingEnabled() {
       // For lti users logged in directly to playposit OR a user launching from a LMS:
       return (
        (
          this.instructorType === 'institutionLTI'
          || this.LTIlaunch
        )
        &&
        (
          this.enableGrading === 1
          || this.playlistSelected?.enableGrading === 1
          || (
            Array.isArray(this?.playlistSelected?.enableGrading?.data) // due to LTI 1.3 data schema differences...
              ? this?.playlistSelected?.enableGrading?.data[0] === 1
              : this?.playlistSelected?.enableGrading
            )
        )
      );
    },
    selectedDataFilteredForBulbs() {
      return this.selectedData.filter(bulb => bulb.isFolder === 0);
    },
    checkForSyncData: function() {
      /**
       * Returns Boolean for enabling/disabling Grade Sync and parses resource_link and consumer_key for bulb export
       *
       * Bulbs: scan the correct bulbAttempt data to extract the bulb_attempt.resource_link_id and split into
       *  resource_link_id and consumer_key
       *
       * Playlists: Grade Sync button is only visible for classes launched from LTI and the contentId,
       *   sectionId, and renderPath are passed instead of the resourceLinkId
       *
       */
      if (this.activeViewInstructor === 'Gradebook' && this.selectedPlaylist !== 'All Bulbs') {
        // playlist, allow export
        return true;
      }
      let consumerResource = false;
      let attempts = [];

      if (this.activeViewInstructor === 'Interactions') {
        attempts = _.get(this.interactions, 'data', []);
      } else if (this.activeViewInstructor === 'Learner-Made-Bulb'){
        attempts = _.get(this.lmb, 'data', []);
      } else if (this.activeViewInstructor === 'Peer-Review'){
        attempts = _.get(this.peerreview, 'data', []);
      }

      attempts.forEach(attempt => {
        if (attempt.resource_link_id) {
          if (!consumerResource) {
            const ck  = attempt.resource_link_id.split('_')[0];
            const rid = attempt.resource_link_id.split(/_(.+)/)[1];
            if (rid !== 'playlist') {
              consumerResource = attempt.resource_link_id;
              this.activeConsumerKey  = ck;
              this.activeResourceLinkId = rid;
            }
          } else if (
            consumerResource
            && attempt.resource_link_id === consumerResource
          ) {
            // toast mismatching resource links
            console.error('mismatching resourceLinkIds.', attempt.resource_link_id, consumerResource)
          }
        }
      })
      return !!consumerResource;
    },
    premadeFilters: function(){
      let obj = {}
      if(this.filterSearch.creator_name != '') {
        obj['Creator'] = [this.filterSearch.creator_name];
      }
      if(this.filterSearch.name.length > 0) {
        obj['Bulb-Name'] = [];
        this.filterSearch.name.forEach((item, index) => {
          obj['Bulb-Name'].push(item);
        })
      }
      if(this.filterSearch.creator.length > 0) {
        obj['Creator-Name'] = [];
        this.filterSearch.creator.forEach((item, index) => {
          obj['Creator-Name'].push(item);
        })
      }
      if(this.filterSearch.age.length > 0) {
        obj['Audience'] = [];
        this.filterSearch.age.forEach((item, index) => {
          obj['Audience'].push(item);
        })
      }
      if(this.filterSearch.subject.length > 0) {
        obj['Subject'] = [];
        this.filterSearch.subject.forEach((item, index) => {
          obj['Subject'].push(item);
        })
      }
      if(this.filterSearch.keywords.length > 0){
        obj['Keywords/Tags'] = [];
        this.filterSearch.keywords.forEach((item, index) => {
          obj['Keywords/Tags'].push(item);
        })
      }
      if (this.filterSearch.excludeTags.length > 0) {
        obj['Exclude Tags'] = [];
        this.filterSearch.excludeTags.forEach((item) => {
          obj['Exclude Tags'].push(item);
        })
      }
      if(this.filterSearch.bulbRole.length > 0){
        obj['Bulb-Role'] = [];
        this.filterSearch.bulbRole.forEach((item, index) => {
          obj['Bulb-Role'].push(item);
        })
      }

      if(this.filterSearch.legacy){
        obj['Classic'] = ['Classic Bulbs Only'];
      }
      if(this.filterSearch.youtube != ''){
        obj['Youtube-Video'] = [`...${this.filterSearch.youtube}`];
      }
      if(this.filterSearch.all_district === false){
        obj['Organization'] = [`My Site Bulbs Only`];
      }
      if(this.filterSearch.bulbId && this.filterSearch.bulbId.length > 0){
        obj['Bulb-Id'] = [];
        this.filterSearch.bulbId.forEach((item) => {
          obj['Bulb-Id'].push(item);
        });
      }
      if(this.filterSearch.playlistRole.length > 0){
        obj['Playlist-Role'] = [];
        this.filterSearch.playlistRole.forEach((item) => {
          obj['Playlist-Role'].push(item);
        })
      }
      if(this.filterSearch.playlistId && this.filterSearch.playlistId.length > 0){
        obj['Playlist-Id'] = [];
        this.filterSearch.playlistId.forEach((item) => {
          obj['Playlist-Id'].push(item);
        });
      }

      return obj;
    },
  },
  methods: {
  ...mapActions('instructors', [
    'createNewPlaylist',
    'getPlaylistGradebookData',
    'managePlaylist',
    'exportGoogleGrades',
    'getNestedBulbsInSelectedFolders'
  ]),
  ...mapMutations('instructors', [
    'toggleEditGrades',
    'updateShowPointsMode',
  ]),
  ...mapMutations([
    'handleDialogOpen',
    'slideOut',
    'setDashModal'
  ]),
  async foldersBatchSettings() {
    try {
      const bulbs = await this.getNestedBulbsInSelectedFolders(this.selectedData);
      if (bulbs.length > 0) {
        this.slideOut({ toggle: true, view: 'batchSettings', location: 'Folders', bulbs: bulbs });
      } else {
        this.$store.commit('triggerSnackbar', {text:"There are no bulbs within the selected folders.", color: 'red', timeout: 4000});
      }
    } catch(e) {
      throw(e);
    }
  },
  returnToProquestMonitorPage() {
    this.$router.back();
  },
  handleCreatePlaylist() {
    this.createNewPlaylist();
  },
  handleDirectURLClicked() {
    this.setDashModal({
      type: 'directClassURL',
      sectionId: this.queryParamsInstructors.section_id,
      schoolId: _.get(this, 'school.id', null),
    });
  },
  handlePickerMessageReceived(event) {
    if (event.data.type === 'playposit__class_import') {
      this.$store.commit('instructors/refreshData');
    }
  },
  handleGoogleClassPicker() {
    const left = window.screenX + 650;
    const top = window.screenY + 35;
    window.open(`${window.location.origin}/dash/googleClassPicker`, 'googleClassPicker', `width=900, height=650, top=${top}, left=${left}`);
    window.addEventListener("message", this.handlePickerMessageReceived);
  },
  loadPlaylistGradebook() {
    this.$store.commit('instructors/setQueryParams', { playlistGradebook: this.selectedPlaylist });
    this.$store.dispatch('instructors/updateUrl');
    if (this.selectedPlaylist === 'All Bulbs'){
      this.$store.dispatch('instructors/getTableData');
    } else {
      this.$store.commit('instructors/setFiltersInteractions', {
        selectedStatus: 'All',
        showPointsBadges: false,
        localShowPointsBadges: false,
        isFiltered: false,
        refreshData: this.filtersInteraction.selectedStatus !== 'All',
      });
      this.getPlaylistGradebookData(this.selectedPlaylist);
    }
  },
  manageCoOwners() {
    this.ownsAllBulbs = true;
    for (const bulb of this.selectedData) {
      // Check to make sure user owns all bulbs selected
      if (bulb.bulb_role !== 1) {
        this.$store.commit('triggerSnackbar', {text:"Only bulb owner can share access.  Check your selection for bulbs you do not own.", color: 'red', timeout: 6000});
        this.ownsAllBulbs = false;
      }
    }
    // User owns all the bulbs selected - launch share modal
    if (this.ownsAllBulbs) this.handleDialogOpen({type:'shareMenu' , data:{bulbs: this.selectedData, name: this.selectedData[0].name, id: this.selectedData[0].id, lmb_id: this.selectedData.lmb_id, bulb_role: 1}});
  },
  async manageCoOwnersForFolders() {
    this.ownsAllBulbs = true;
    const bulbs = await this.getNestedBulbsInSelectedFolders(this.selectedData);
    for (const bulb of bulbs) {
      // Check to make sure user owns all bulbs selected
      if (bulb.bulb_role !== 1) {
        this.$store.commit('triggerSnackbar', {text:"Only bulb owner can share access.  Check your selection for bulbs you do not own.", color: 'red', timeout: 6000});
        this.ownsAllBulbs = false;
      }
    }
    if (bulbs.length > 0) {
      this.$store.commit('instructors/setSelectedData', bulbs);
      // User owns all the bulbs selected - launch share modal
      if (this.ownsAllBulbs) this.handleDialogOpen({type:'shareMenu' , data:{bulbs: bulbs, name: bulbs[0].name, id: bulbs[0].id, lmb_id: bulbs.lmb_id, bulb_role: 1}});
    } else {
      this.$store.commit('triggerSnackbar', {text:"There are no bulbs within the selected folders.", color: 'red', timeout: 4000});
    }
  },
  search: function(){
      //updates data and url based on search
      const params = {
        page: 1,
        per_page: 20,
      };
      if (_.has(this.$route, 'query.playlistGradebook')) params.playlistGradebook = _.get(this.$route, 'query.playlistGradebook');
      this.$store.commit('instructors/setQueryParams', params);
      this.$store.dispatch('instructors/getTableData');
      this.$store.dispatch('instructors/updateUrl');
    },
    clearSearch: function(){
      this.$store.commit('instructors/setQueryParams', {search:""});
      this.$store.dispatch('instructors/updateUrl');
      this.$store.dispatch('instructors/getTableData');
    },
    refresh: function() {
      //updates data
      if(
        this.activeViewInstructor != 'Premade-Bulbs'
        && this.activeViewInstructor != 'My-Community'
        && this.activeViewInstructor != 'Premade-Bulbs-Legacy'
        && this.activeViewInstructor != 'My-Community-Legacy'
      ) {
        this.$store.dispatch('instructors/getTableData');
      } else {
        this.$store.dispatch('instructors/getPremadeTableData', {});
      }
    },
    addBulb: function() {
      const windowRef = window.open(`${this.designerApiPrefix}/designer/?bulb_id=new&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
      const windowRefInterval = setInterval(() => {
        if (windowRef?.closed) {
          clearInterval(windowRefInterval);
          this.$store.commit(
            'triggerSnackbar', {
              text: 'Bulb successfully created!',
              color: 'green',
              timeout: 7000,
          });
          this.refresh();
        }
      }, 1000);
    },
    uploadLearners: function(){
      this.$store.dispatch('sendManualLog',{category:'learners', action:'open student uploader'});
      //adding students- opens up csv uploader
      this.$store.commit('slideOut', {toggle: true, view: 'student'});
    },
    syncLti: function({ contentId, renderPath, }) { // this shit is the worst
      /**
       * There are now two API routes for ltiSyncing
       *  A: /sync/section/:sectionId/content/:contentId/:renderPath?consumer_key=:consumerKey
       *  B: /syncltigrades?consumer_key=:consumerKey&resource_link_id=:resourceLinkId&section_id=:sectionId
       *
       * A is a wrapper for B that uses contentId, sectionId, renderPath to find the correct resource_link_id
       *  Playlists will pass values for A
       *  Bulbs will pass values for B
       * The Vuex action determines which route to use based on these values
       */

      if (this.isGradingEnabled) {
        this.$store.dispatch('syncLti', {
          contentId, // passed for playlist
          sectionId: this.queryParamsInstructors.section_id,
          renderPath, // passed for playlist
          resourceLinkId: this.activeResourceLinkId, // passed for play2, broadcast2, studentmade2, render_path is unknown on this page
          consumerKey: this.activeConsumerKey || this.LTIdata.consumer_key,
          issuer: this?.$route?.query?.issuer ?? this?.LTIdata?.issuer,
        });
      } else {
        this.$store.commit(
          'triggerSnackbar',
          {
            text:"Grade export not supported for this type of launch.",
            color: 'red',
            timeout: 6000,
          }
        );
      }
    },
    closeInteractionFilterTag(key) {
      const selectedStatus = key === 'selectedStatus' ? 'All' : this.filtersInteraction.selectedStatus;
      const showPointsBadges = key === 'showPointsBadges' ? false : this.filtersInteraction.showPointsBadges;
      const localShowPointsBadges = key === 'showPointsBadges' ? false : this.filtersInteraction.showPointsBadges;
      this.$store.commit('instructors/setFiltersInteractions', {
        selectedStatus,
        showPointsBadges,
        localShowPointsBadges,
        refreshData: key === 'selectedStatus',
        isFiltered: (
          selectedStatus !== 'All'
          || showPointsBadges
        ),
      });
    },
    clearFilter: function(type) {
      //reset query params and update url
      this.$store.commit('instructors/setQueryParams', {sort:'', page:1, per_page:20, search: ''});

      if(type[0] === "Classic" && this.activeViewInstructor === 'Premade-Bulbs-Legacy'){
        this.$store.commit('instructors/setActiveView', ['Premade-Bulbs']);
        this.$store.dispatch('instructors/updateUrl');
      }
      if(type[0] === "Classic"  && this.activeViewInstructor === 'My-Community-Legacy'){
        this.$store.commit('instructors/setActiveView', ['My-Community']);
        this.$store.dispatch('instructors/updateUrl');
      }
      this.$store.commit('instructors/clearFilter', type);
    },
    clearAllFilters: function(){
      //reset query params and update url
      this.$store.commit('instructors/setQueryParams', {sort:'', page:1, per_page:20, search: ''});
      this.$store.dispatch('instructors/updateUrl');

      if(this.filterSearch.legacy && this.activeViewInstructor === 'Premade-Bulbs-Legacy'){
        this.$store.commit('instructors/setActiveView', ['Premade-Bulbs']);
        this.$store.dispatch('instructors/updateUrl');
      }
      if(this.filterSearch.legacy && this.activeViewInstructor === 'My-Community-Legacy'){
        this.$store.commit('instructors/setActiveView', ['My-Community']);
        this.$store.dispatch('instructors/updateUrl');
      }
      this.$store.commit('instructors/clearAllFilters');
      this.$store.commit('instructors/refreshData');
    },
    tagStyle: function(type){
      let color;

      let category;

      switch(type){
        case 'Audience':
          category = 'age';
          break;
        case 'Subject':
          category = 'subject';
          break;
        case 'Keywords/Tags':
          category = 'user-generated';
        default:
          category = 'user-generated';
          break;
      }


      if(type === 'Creator' || type === 'Creator-Name'){
        color = '#b2ebf2'
      } else if(type === 'Bulb-Name') {
        color = '#DCEDC8'
      } else if(type === 'Youtube-Video') {
        color = '#D7CCC8'
      } else if(type === 'Classic') {
        color = '#E1BEE7'
      } else {
        this.tags.rawData.forEach(item => {
          if(item.type === category) color = item.hex;
        })
      }

      let darkColor = Color(color).darken(0.60).hex();
      return {
        'backgroundColor': color,
        'color': `${darkColor} !important`,
        'border': `solid 1px ${darkColor} !important`,
      }
    },
    tagTextStyle: function(type){
      let color;
      let category;

      switch(type){
        case 'Audience':
          category = 'age';
          break;
        case 'Subject':
          category = 'subject';
          break;
        case 'Keywords/Tags':
          category = 'user-generated';
        default:
          category = 'user-generated';
          break;
      }


      if(type === 'Creator' || type === 'Creator-Name'){
        color = '#b2ebf2'
      } else if(type === 'Bulb-Name') {
        color = '#DCEDC8'
      } else if(type === 'Youtube-Video') {
        color = '#D7CCC8'
      } else if(type === 'Classic') {
        color = '#E1BEE7'
      } else {
        this.tags.rawData.forEach(item => {
          if(item.type === category) color = item.hex;
        })
      }

      let darkColor = Color(color).darken(0.60).hex();
      return {
        'color': `${darkColor} !important`,
      }
    },
    async syncGoogleGrades() {
      try {
        const bulbAttemptIds = [];
        const playlistAttemptIds = [];
        if (this.activeViewInstructor === 'Interactions') {
          for (const interaction of this.interactions.data) {
            if (
              _.has(interaction, 'bulbattempt_id')
              && _.get(interaction, 'studentSubmissionId', false)
            ) bulbAttemptIds.push(interaction.bulbattempt_id);
          }
        } else {
          for (const attempt of this.gradebook.data) {
            if (
              _.find(attempt, { 'archivedAttempt': false })
              && _.get(attempt, 'playlistAttempt.studentSubmissionId', false)
            ) {
              playlistAttemptIds.push(attempt?.playlistAttempt?.playlistAttemptId);
            }
          }
        }
        if (
          bulbAttemptIds.length
          || playlistAttemptIds.length
        ) {
            await this.exportGoogleGrades({
              bulbAttemptIds,
              playlistAttemptIds,
              courseId: this.selectedClass.key.substring(1),
              courseWorkId: bulbAttemptIds.length ? this.courseWorkId : this.selectedPlaylistCourseWorkId,
              sectionId: this.selectedClass.id,
            });
        } else {
          this.$store.commit('triggerSnackbar',
            {
              text:"No student grades to export.",
              color: 'warning',
              timeout: 6000
            });
        }
      } catch(e) {
        this.$store.commit('triggerSnackbar',
          {
            text:"Error exporting grades.",
            color: 'warning',
            timeout: 6000
          });
      }
    },
    calculateFilterMenuNudgeLeft() {
      this.windowInnerWidth = window.innerWidth;
      if (this.windowInnerWidth <= 1053 ) {
        this.filterMenuNudgeLeft = 400;
      } else {
        this.filterMenuNudgeLeft = 530;
      }
    },
  },
  watch: {
    searchWatch: {
      handler: function(val, oldVal){
        //if search is reset, calls data refresh
        if(val === '' && oldVal != ''){
          this.search();
        }
      }
    },
    classesLoaded: {
      handler: function (val){
        if(val){
          this.classes.data.forEach(item => {
            if(this.queryParamsInstructors.section_id === item.id){
              this.lmsImg = (item.lmsImg || this?.LMSdata?.img);
            }
          })
        }
      }
    },
    sectionId: {
      handler: function (val){
        this.classes.data.forEach(item => {
          if(val == item.id){
            this.lmsImg = (item.lmsImg || this?.LMSdata?.img);
          }
        })
      }
    },
    slideOutLarge: {
      // [ ] Should this still be here?
      handler(n, o) {
        // Refresh the table after exiting the rubric editor to refresh the correct bulb.pointsAvailable value.
        if (
          this.activeViewInstructor === 'My-Bulbs'
          && !_.get(n, 'toggle')
          && !_.get(n, 'view')
          && _.get(o, 'toggle')
          && _.get(o, 'view') === 'rubric'
        ) this.refresh();
      },
      deep: true,
    },
    'activeViewInstructor' (n, o) {
      if (n !== 'Gradebook') this.selectedPlaylist = 'All Bulbs';
    },
    sectionPlaylists (newValue, oldValue) {
      if (
        !this.queryParamsInstructors.playlistGradebook
        && !this.selectedPlaylist
        && !_.find(this.sectionPlaylists, { id: parseInt(_.get(this.$route, 'query.playlistGradebook', 0), 10) })
      ) {
        this.selectedPlaylist = 'All Bulbs';
      }
    }
  },
  async mounted() {
    window.PP.InstructorTableToolbar = {
      vm: this,
    };
    if (_.get(this.$route, 'query.playlistGradebook', false)) {
      this.selectedPlaylist = parseInt(_.get(this.$route, 'query.playlistGradebook'), 10);
      this.$store.commit('instructors/setQueryParams', { playlistGradebook: this.selectedPlaylist });
    }
    // This is for if the monitor button redirect occurs in a new window.
    await this.$nextTick();
    if (
      this.$route.path.includes('instructor/Classes')
      && !_.get(this, 'classes.data.length')
    ) {
      this.$store.dispatch('instructors/getClasses');
    }
    this.calculateFilterMenuNudgeLeft();
    window.addEventListener('resize', this.calculateFilterMenuNudgeLeft);
  },
  updated() {
    if (
      _.get(this.$route, 'query.playlistGradebook')
      && _.get(this.$route, 'query.playlistGradebook') !== this.selectedPlaylist
    ) {
        this.selectedPlaylist = _.get(this.$route, 'query.playlistGradebook') === 'All Bulbs'  ?
        _.get(this.$route, 'query.playlistGradebook')
        : parseInt(_.get(this.$route, 'query.playlistGradebook'), 10);
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handlePickerMessageReceived);
    window.removeEventListener('resize', this.calculateFilterMenuNudgeLeft);
  },
};
</script>

<style scoped>
  .chip-container{
    height: 45px;
    background-color: #fff;
  }
  .selectClassTruncate {
    min-width: 280px;
  }
  div .selectClassTruncate >>> .v-select__selection--comma {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  #addClassMenu {
    box-shadow: none;
  }
  .playlistSelect {
    max-width: 280px;
  }
</style>
